import { render, staticRenderFns } from "./co_seller.vue?vue&type=template&id=8645237e&"
import script from "./co_seller.vue?vue&type=script&lang=js&"
export * from "./co_seller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports